import React, { Component, useState, useEffect, useRef } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import colorArray from "../../helpers/colorArray"
import _ from "lodash"
import { Pie, Bar, Line } from "react-chartjs-2"
import clone from "clone"
import lineOptions from "helpers/lineOptions"
import pieOptions from "helpers/pieOptions"
import { loadingStatus } from "actions"
import capitalize from "helpers/capitalize"
import ImageExport from "components/ImageExport"
import settings from "settings"
import FullTable from "components/FullTable"
import ReactSelect from "components/ReactSelect"
import Switch from "react-switch"
import getData from "helpers/submitData"
import * as mapboxgl from "mapbox-gl"
mapboxgl.accessToken = settings.mapboxKey
import "mapbox-gl/dist/mapbox-gl.css"

function MarketingGeographics(props) {
	const mapContainer = useRef(null)
	const [hideFlags, setHideFlags] = useState({ buyerAge: null })
	const [chartFlags, setChartFlags] = useState({ city: "pie" })
	const [activeLotTypes, setActiveLotTypes] = useState([])
	const [sales, setSales] = useState(true)
	const [traffic, setTraffic] = useState(false)
	const [leads, setLeads] = useState(false)
	const [data, setData] = useState(false) // this is leads
	const [map, setMap] = useState(null)
	const [mapData, setMapData] = useState(null)

	useEffect(() => {
		if (props.payloadStatus) {
			props.loadingStatus(true)
			pullData()
			buildMapData()
		}
	}, [props.payloadStatus])

	let pullData = () => {
		getData("getLeads", { dates: props.currentDates, activeProperties: props.activeProperties })
			.then((resp) => {
				setData(resp.data)
				props.loadingStatus(false)
			})
			.catch((e) => {
				console.log(e)
			})
	}

	useEffect(() => {
		if (data) {
			if (map) map?.remove()
			setMap(null)
			//initMap()
			initMapZips()
		}
	}, [data])

	useEffect(() => {
		buildMapData()
	}, [sales, traffic, leads, activeLotTypes])

	useEffect(() => {
		if (map) {
			map.getSource("zips").setData(mapData)
			if (map.getLayer("zips-heat")) {
				let paint = calculatePaint()
				if (!paint) return
				if (paint["heatmap-weight"])
					map.setPaintProperty("zips-heat", "heatmap-weight", paint["heatmap-weight"])
				if (paint["heatmap-radius"])
					map.setPaintProperty("zips-heat", "heatmap-radius", paint["heatmap-radius"])
			}
		}
	}, [mapData])

	const produceChart = (name, data) => {
		let chart = chartFlags[name]
		if (chart == "pie") {
			return <Pie data={data[chart].data} options={data[chart].opts} />
		} else if (chart == "line") {
			return <Line data={data[chart].data} options={data[chart].opts} />
		} else if (chart == "bar") {
			return <Bar data={data[chart].data} options={data[chart].opts} />
		}
	}

	const city = () => {
		let tmpCities = {}
		let tmpCityState = {}
		if (sales) {
			_.forEach(props.payload.sales.current, (v) => {
				if (activeLotTypes.length > 0 && !activeLotTypes.includes(v.lot_type)) return
				if (!v.buyer_city || !v.sale_date) {
					return
				}
				if (!props.activeProperties.includes(v.property)) {
					return
				}
				let city = v.buyer_city.replace(/[^a-zA-Z0-9_ ]/g, "").trim()
				city = capitalize(city)
				let path = `${v.buyer_state}.${city}.sales`
				if (!_.has(tmpCityState, path)) {
					_.set(tmpCityState, path, 0)
					if (v.buyer_state) _.set(tmpCityState, `${v.buyer_state}.${city}.sales`, 0)
				}
				if (v.buyer_state) tmpCityState[v.buyer_state][city].sales++
			})
		}
		if (traffic) {
			_.forEach(props.payload.traffic.current.entries, (v) => {
				if (!v.city || !v.state) return
				let city = v.city.replace(/[^a-zA-Z0-9_ ]/g, "").trim()
				city = capitalize(city)
				let path = `${v.state}.${city}.traffic`
				if (!_.has(tmpCityState, path)) {
					_.set(tmpCityState, path, 0)
					if (v.state) _.set(tmpCityState, `${v.state}.${city}.traffic`, 0)
				}
				if (v.state) tmpCityState[v.state][city].traffic++
			})
		}
		if (leads) {
			_.forEach(data, (v) => {
				if (!v.city || !v.state) return
				let city = v.city.replace(/[^a-zA-Z0-9_ ]/g, "").trim()
				city = capitalize(city)
				let path = `${v.state}.${city}.leads`
				if (!_.has(tmpCityState, path)) {
					_.set(tmpCityState, path, 0)
					if (v.state) _.set(tmpCityState, `${v.state}.${city}.leads`, 0)
				}
				if (v.state) tmpCityState[v.state][city].leads++
			})
		}

		_.forEach(tmpCityState, (v, state) => {
			_.forEach(v, (r, city) => {
				let total = 0
				if (r.sales) total += r.sales
				if (r.traffic) total += r.traffic
				if (r.leads) total += r.leads
				tmpCities[`${city},${state}`] = total
			})
		})
		let sorted = {}
		_.forEach(tmpCities, (v, k) => {
			sorted = _(tmpCities).toPairs().orderBy(1, "desc").fromPairs().value()
		})
		let keys = {}
		_.forEach(sorted, (v, k) => {
			keys = _.keys(sorted).slice(0, 6)
		})
		let d = {}
		_.forEach(keys, (city) => {
			_.set(d, `${city}`, sorted[city])
		})
		let pieData = {
			datasets: [
				{
					data: Object.values(d),
					backgroundColor: colorArray,
					labels: Object.keys(d),
				},
			],
			labels: Object.keys(d),
		}

		let lineData = clone(pieData)
		_.forEach(lineData.datasets, (v, k) => {
			lineData.datasets[k].borderColor = settings.primaryColor
			lineData.datasets[k].fill = false
			lineData.datasets[k].pointBorderColor = settings.primaryColor
			lineData.datasets[k].pointBackgroundColor = settings.primaryColor
		})

		delete lineOptions.legend
		let tableData = []
		_.forEach(tmpCityState, (v, state) => {
			_.forEach(v, (r, city) => {
				tableData.push({
					city,
					state,
					sales: r.sales || 0,
					traffic: r.traffic || 0,
					leads: r.leads || 0,
				})
			})
		})
		const columns = [
			{
				Header: "City",
				accessor: "city",
			},
			{
				Header: "State",
				accessor: "state",
			},
		]
		if (sales) columns.push({ Header: "Number of Sales", accessor: "sales" })
		if (traffic) columns.push({ Header: "Traffic", accessor: "traffic" })
		if (leads) columns.push({ Header: "Leads", accessor: "leads" })
		let dataContainer = {
			pie: {
				data: pieData,
				opts: pieOptions,
			},
			bar: {
				data: lineData,
				opts: lineOptions,
			},
			line: {
				data: lineData,
				opts: lineOptions,
			},
		}

		return (
			<div className="statBox__row statBox__row--threeOne">
				<div className="statBox__box">
					<ImageExport name="MovingFromCity" />
					<h3 className="statBox__title">Moving From City</h3>
					{produceChart("city", dataContainer)}
				</div>
				<div className="statBox__box">
					<FullTable
						data={tableData}
						columns={columns}
						name="geographics__moveFrom"
						title="Move From City"
						reInit={true}
						defaultSorted={[
							{
								id: "sales",
								desc: true,
							},
						]}
					/>
				</div>
			</div>
		)
	}

	const zip = () => {
		try {
			let breakout = {}
			let model = { sales: 0, traffic: 0, leads: 0, total: 0 }
			if (sales) {
				_.forEach(props.payload.sales.current, (v) => {
					if (activeLotTypes.length > 0 && !activeLotTypes.includes(v.lot_type)) return
					if (!v.buyer_zip || !v.sale_date) {
						return
					}
					if (!props.activeProperties.includes(v.property)) {
						return
					}
					if (!breakout.hasOwnProperty(v.buyer_zip)) {
						_.set(breakout, `${v.buyer_zip}`, _.cloneDeep(model))
					}
					breakout[v.buyer_zip].sales++
				})
			}
			if (traffic) {
				_.forEach(props.payload.traffic.current.entries, (v) => {
					if (!v.zip) return
					if (!breakout.hasOwnProperty(v.zip)) {
						_.set(breakout, `${v.zip}`, _.cloneDeep(model))
					}
					breakout[v.zip].traffic++
				})
			}
			if (leads) {
				_.forEach(data, (v) => {
					if (!v.zip) return
					if (!breakout.hasOwnProperty(v.zip)) {
						_.set(breakout, `${v.zip}`, _.cloneDeep(model))
					}
					breakout[v.zip].leads++
				})
			}
			_.forEach(breakout, (v, k) => {
				let total = 0
				if (v.sales) total += v.sales
				if (v.traffic) total += v.traffic
				if (v.leads) total += v.leads
				v.total = total
			})
			const top10 = Object.entries(breakout)
				.sort((a, b) => b[1].total - a[1].total)
				.slice(0, 10)

			let f = {
				datasets: [
					{
						data: _.map(top10, (v) => v[1].total),
						backgroundColor: colorArray,
						labels: _.map(top10, (v) => v[0]),
					},
				],
				labels: _.map(top10, (v) => v[0]),
			}

			// Now onto table
			// compile table object
			let tableData = _.map(breakout, (v, k) => {
				return {
					zip: k,
					sales: v.sales,
					traffic: v.traffic,
					leads: v.leads,
				}
			})
			const columns = [
				{
					Header: "Zip",
					accessor: "zip",
				},
			]
			if (sales) columns.push({ Header: "Number of Sales", accessor: "sales" })
			if (traffic) columns.push({ Header: "Traffic", accessor: "traffic" })
			if (leads) columns.push({ Header: "Leads", accessor: "leads" })
			const opts = {
				legend: {
					display: true,
					position: "bottom",
				},
			}
			return (
				<div className="statBox__row statBox__row--threeOne">
					<div className="statBox__box">
						<ImageExport name="ZipCodes" />
						<h3 className="statBox__title">Zip Codes</h3>
						<Pie data={f} options={opts} />
					</div>
					<div className="statBox__box">
						<FullTable
							data={tableData}
							columns={columns}
							name="geographics__country"
							title="Move From Country"
							reInit={true}
							defaultSorted={[
								{
									id: "sales",
									desc: true,
								},
							]}
						/>
					</div>
				</div>
			)
		} catch (e) {
			console.log(e)
			return ""
		}
		
	}

	const outOfState = () => {
		let tmpState = {}
		let store = {}
		// List of states the selected communities are in
		let exStates = []
		_.forEach(props.activeProperties, (v) => {
			let f = _.find(props.payload.public.properties, { id: v })
			if (f) {
				exStates.push(f.state?.toUpperCase())
			}
		})
		if (sales) {
			_.forEach(props.payload.sales.current, (v) => {
				if (activeLotTypes.length > 0 && !activeLotTypes.includes(v.lot_type)) return
				if (!v.buyer_state || !v.sale_date) {
					return
				}
				if (!props.activeProperties.includes(v.property)) {
					return
				}
				let state = v.buyer_state.replace(/\W /g, "").trim()
				// Skip selected states
				state = capitalize(state)
				let statecheck = state.toUpperCase()
				if (exStates.includes(statecheck)) {
					return
				}
				/* if (!tmpState.hasOwnProperty(state)) {
					_.set(tmpState, `${state}.sales`, 0)
				}
				tmpState[state].sales++ */
				let path = `${state}.sales`
				if (!_.has(tmpState, path)) {
					_.set(tmpState, path, 0)
					if (state) _.set(tmpState, `${state}.sales`, 0)
				}
				if (state) tmpState[state].sales++
			})
		}
		if (traffic) {
			_.forEach(props.payload.traffic.current.entries, (v) => {
				if (!v.state) return
				let state = v.state.replace(/\W /g, "").trim()
				state = capitalize(state)
				if (exStates.includes(state)) {
					return
				}
				let path = `${state}.traffic`
				if (!_.has(tmpState, path)) {
					_.set(tmpState, path, 0)
					if (state) _.set(tmpState, `${state}.traffic`, 0)
				}
				if (state) tmpState[state].traffic++
			})
		}
		if (leads) {
			_.forEach(data, (v) => {
				if (!v.state) return
				let state = v.state.replace(/\W /g, "").trim()
				state = capitalize(state)
				if (exStates.includes(state)) {
					return
				}
				let path = `${state}.leads`
				if (!_.has(tmpState, path)) {
					_.set(tmpState, path, 0)
					if (state) _.set(tmpState, `${state}.leads`, 0)
				}
				if (state) tmpState[state].leads++
			})
		}
		store = _.cloneDeep(tmpState)
		_.forEach(tmpState, (r, state) => {
			let total = 0
			if (r.sales) total += r.sales
			if (r.traffic) total += r.traffic
			if (r.leads) total += r.leads
			tmpState[state] = total
		})
		let sorted = {}
		_.forEach(tmpState, (v, k) => {
			sorted = _(tmpState).toPairs().orderBy(1, "desc").fromPairs().value()
		})
		let keys = {}
		_.forEach(sorted, (v, k) => {
			keys = _.keys(sorted).slice(0, 6)
		})
		let d = {}
		_.forEach(keys, (state) => {
			_.set(d, `${state}`, sorted[state])
		})
		let obj = {
			datasets: [
				{
					data: Object.values(d),
					backgroundColor: colorArray,
					labels: Object.keys(d),
				},
			],
			labels: Object.keys(d),
		}

		// Now onto table
		// compile table object
		let tableData = _.map(store, (v, k) => {
			return {
				state: k,
				sales: v.sales || 0,
				traffic: v.traffic || 0,
				leads: v.leads || 0,
			}
		})
		const columns = [
			{
				Header: "State",
				accessor: "state",
			},
		]
		if (sales) columns.push({ Header: "Number of Sales", accessor: "sales" })
		if (traffic) columns.push({ Header: "Traffic", accessor: "traffic" })
		if (leads) columns.push({ Header: "Leads", accessor: "leads" })
		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<div className="statBox__row statBox__row--threeOne">
				<div className="statBox__box">
					<ImageExport name="MovingFromState" />
					<h3 className="statBox__title">Moving From Other State</h3>
					<Pie data={obj} options={opts} />
				</div>
				<div className="statBox__box">
					<FullTable
						data={tableData}
						columns={columns}
						name="geographics__state"
						title="Move From State"
						reInit={true}
						defaultSorted={[
							{
								id: "sales",
								desc: true,
							},
						]}
					/>
				</div>
			</div>
		)
	}

	const outOfCountry = () => {
		let tmpCountry = {}
		_.forEach(props.payload.sales.current, (v) => {
			if (activeLotTypes.length > 0 && !activeLotTypes.includes(v.lot_type)) return
			// Skip Country
			if (!v.buyer_country || !v.sale_date) {
				return
			}
			if (!props.activeProperties.includes(v.property)) {
				return
			}
			let country = v.buyer_country.replace(/[^a-zA-Z0-9_ ]/g, "").trim()
			// Skip USA
			country = capitalize(country)
			let countrycheck = country.toLowerCase()
			if (countrycheck == "usa" || countrycheck == "us" || countrycheck.includes("usa")) {
				return
			}
			if (!tmpCountry.hasOwnProperty(country)) {
				_.set(tmpCountry, `${country}`, 0)
			}
			tmpCountry[country]++
		})
		let sorted = {}
		_.forEach(tmpCountry, (v, k) => {
			sorted = _(tmpCountry).toPairs().orderBy(1, "desc").fromPairs().value()
		})
		let keys = {}
		_.forEach(sorted, (v, k) => {
			keys = _.keys(sorted).slice(0, 6)
		})
		let d = {}
		_.forEach(keys, (country) => {
			_.set(d, `${country}`, sorted[country])
		})
		let data = {
			datasets: [
				{
					data: Object.values(d),
					backgroundColor: colorArray,
					labels: Object.keys(d),
				},
			],
			labels: Object.keys(d),
		}

		// Now onto table
		// compile table object

		let tableData = _.map(tmpCountry, (v, k) => {
			return {
				country: k,
				sales: v,
			}
		})
		const columns = [
			{
				Header: "Country",
				accessor: "country",
			},
		]
		if (sales) columns.push({ Header: "Number of Sales", accessor: "sales" })
		if (traffic) columns.push({ Header: "Traffic", accessor: "traffic" })
		if (leads) columns.push({ Header: "Leads", accessor: "leads" })
		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		return (
			<div className="statBox__row statBox__row--threeOne">
				<div className="statBox__box">
					<ImageExport name="MovingFromCountry" />
					<h3 className="statBox__title">Moving From Other Country</h3>
					<p className="mid infoNote py-2 m-0">
						<i className={`fas fa-info-circle`} />
						Country data only affected by sales.
					</p>
					<Pie data={data} options={opts} />
				</div>
				<div className="statBox__box">
					<FullTable
						data={tableData}
						columns={columns}
						name="geographics__country"
						title="Move From Country"
						reInit={true}
						defaultSorted={[
							{
								id: "sales",
								desc: true,
							},
						]}
					/>
				</div>
			</div>
		)
	}

	const lotTypes = () => {
		let ret = []
		_.forEach(props.payload.public.lot_types, (v) => {
			if (props.activeProperties.includes(v.property)) {
				let property = _.find(props.payload.public.properties, { id: v.property })
				let name = property.name || ""
				ret.push({
					label: props.activeProperties.length > 1 ? `${name} - ${v.name}` : `${v.name}`,
					value: v.id,
				})
			}
		})
		return ret
	}

	const buildMapData = () => {
		// Build a zip dataset with lat/lng for each zip code and counts
		let zips = {}
		if (sales) {
			_.forEach(props.payload.sales.current, (v) => {
				if (activeLotTypes.length > 0 && !activeLotTypes.includes(v.lot_type)) return
				if (!v.buyer_zip || !v.lat || !v.lng) return
				if (!_.has(zips, v.buyer_zip)) {
					_.setWith(zips, v.buyer_zip, { total: 0, lat: v.lat, lng: v.lng }, Object)
				}
				zips[v.buyer_zip].total++
			})
		}
		if (traffic) {
			_.forEach(props.payload.traffic.current.entries, (v) => {
				if (!v.zip || !v.lat || !v.lng) return
				if (!_.has(zips, v.zip)) {
					_.setWith(zips, v.zip, { total: 0, lat: v.lat, lng: v.lng }, Object)
				}
				zips[v.zip].total++
			})
		}
		if (leads) {
			_.forEach(data, (v) => {
				if (!_.has(zips, v.zip)) {
					_.setWith(zips, v.zip, { total: 0, lat: v.lat, lng: v.lng }, Object)
				}
				zips[v.zip].total++
			})
		}

		// now create a geojson object with the zips
		let zipsGeo = {
			type: "FeatureCollection",
			features: [],
		}
		_.forEach(zips, (v, k) => {
			zipsGeo.features.push({
				type: "Feature",
				geometry: {
					type: "Point",
					coordinates: [v.lng, v.lat, 0],
				},
				properties: {
					zip: k,
					total: v.total,
				},
			})
		})
		// order the zips by total
		zipsGeo.features = _.sortBy(zipsGeo.features, "properties.total").reverse()

		setMapData(zipsGeo)
	}

	const calculatePaint = () => {
		let topTotal = mapData?.features?.[0]?.properties?.total
		let cut = topTotal / 10 || 0
		if (!topTotal) return
		return {
			// Increase the heatmap weight based on frequency and property magnitude
			"heatmap-weight": ["interpolate", ["linear"], ["get", "total"], 0, 0, cut, 1],
			// Increase the heatmap color weight weight by zoom level
			// heatmap-intensity is a multiplier on top of heatmap-weight
			"heatmap-intensity": ["interpolate", ["linear"], ["zoom"], 0, 1, 8, 1.5, 11, 2, 14, 2.5],
			// Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
			// Begin color ramp at 0-stop with a 0-transparancy color
			// to create a blur-like effect.
			"heatmap-color": [
				"interpolate",
				["linear"],
				["heatmap-density"],
				0,
				"rgba(33,102,172,0)",
				0.2,
				"rgb(103,169,207)",
				0.4,
				"rgb(209,229,240)",
				0.6,
				"rgb(253,219,199)",
				0.8,
				"rgb(239,138,98)",
				1,
				"rgb(178,24,43)",
			],
			// Adjust the heatmap radius by zoom level
			//"heatmap-radius": ["interpolate", ["linear"], ["zoom"], 0, 60, 9, 100, 16, 200],
			"heatmap-radius": ["interpolate", ["linear"], ["get", "total"], 0, 40, topTotal, 500],
			// Transition from heatmap to circle layer by zoom level
			"heatmap-opacity": ["interpolate", ["linear"], ["zoom"], 1, 0.1, 7, 0.5],
		}
	}

	const initMapZips = () => {
		if (data && props.payloadStatus) {
			let property = _.find(props.payload.public.properties, { id: props.activeProperties[0] })
			if(!property) return
			let center = [property.lng, property.lat]

			// Build a zip dataset with lat/lng for each zip code and counts
			let zipsGeo = mapData
			let paint = calculatePaint()
			const map = new mapboxgl.Map({
				container: mapContainer.current,
				style: "mapbox://styles/mapbox/dark-v11",
				center,
				pitch: 15,
				zoom: 9,
				minZoom: 5,
				maxZoom: 16,
				attributionControl: false,
			})
			// Add navigation control (the +/- zoom buttons)
			map.addControl(new mapboxgl.NavigationControl(), "bottom-right")

			map.on("load", async () => {
				map.addSource("zips", {
					type: "geojson",
					data: zipsGeo,
				})

				map.addLayer(
					{
						id: "zips-heat",
						type: "heatmap",
						source: "zips",
						//maxzoom: 9,
						paint,
					},
					"waterway-label"
				)
				setMap(map)
			})
			//map.scrollZoom.disable()
			// Clean up on unmount
			return () => map.remove()
		}
	}

	if (props.payloadStatus) {
		return (
			<div className="demographics">
				<div className="imageGroup">
					<Title title="Geographics Information" showDate={true} hideFlags={hideFlags} echoActive={true} />
					<div className="statBox">
						<p className="text-xs py-2 m-0 text-neutral-600">
							<i className={`fas fa-info-circle pr-2`} />
							Lot types will only affect sales.
						</p>
						<div className="flex text-blue">
							<div className="min-w-[300px]">
								<h4 className="font-bold">Active Lot Types:</h4>
								<ReactSelect
									name={`activeLotType`}
									options={lotTypes()}
									value={activeLotTypes}
									onBlur={() => {}}
									onChange={(k, v) => {
										if (!v) v = []
										setActiveLotTypes(v)
									}}
									isMulti
								/>
							</div>
							<div className="flex items-center pl-6">
								<Switch
									onChange={() => setSales((s) => !s)}
									checked={sales}
									checkedIcon={false}
									uncheckedIcon={false}
								/>
								<p className="pl-1 font-bold text-sm">Sales</p>
							</div>
							<div className="flex items-center pl-5">
								<Switch
									onChange={() => setTraffic((t) => !t)}
									checked={traffic}
									checkedIcon={false}
									uncheckedIcon={false}
								/>
								<p className="pl-1 font-bold text-sm">Traffic</p>
							</div>
							<div className="flex items-center pl-5">
								<Switch
									onChange={() => setLeads((l) => !l)}
									checked={leads}
									checkedIcon={false}
									uncheckedIcon={false}
								/>
								<p className="pl-1 font-bold text-sm">Leads</p>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div ref={mapContainer} className="h-60v" />
					</div>
					<div className="statBox">
						{city()}
						{zip()}
					</div>
				</div>
				<div className="imageGroup">
					<div className="statBox">
						{outOfState()}
						{outOfCountry()}
					</div>
				</div>
			</div>
		)
	} else {
		return ""
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(MarketingGeographics)
